import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

type CopyEditContextValue = {
  activePath: string | null;
  openEdit: (path: string) => void;
  closeEdit: (path: string) => void;
};

const CopyEditContext = createContext<CopyEditContextValue | undefined>(undefined);

export function CopyEditProvider({ children }: { children: ReactNode }) {
  const [activePath, setActivePath] = useState<string | null>(null);

  const openEdit = useCallback((path: string) => {
    setActivePath(path);
  }, []);

  const closeEdit = useCallback((path: string) => {
    setActivePath((cur) => (cur === path ? null : cur));
  }, []);

  const value = useMemo(
    () => ({ activePath, openEdit, closeEdit }),
    [activePath, openEdit, closeEdit],
  );

  return <CopyEditContext.Provider value={value}>{children}</CopyEditContext.Provider>;
}

export function useCopyEdit(): CopyEditContextValue {
  const ctx = useContext(CopyEditContext);
  if (!ctx) throw new Error("useCopyEdit must be used inside <CopyEditProvider>");
  return ctx;
}
